import { createStyles, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() =>
  createStyles({
    root: { display: 'flex' },
    drawer: {
      marginTop: '4rem',
      width: 7,
      flexShrink: 0
    },
    drawerPaper: {
      width: '100%'
    },
    list: {
      width: 250,
      height: '100%'
    },
    fullList: {
      marginTop: '4rem',
      width: '100%',
      transition: '5000ms ease'
    }
  })
)
